export enum PaymentEntityType {
  Reservation = 'reservation',
  ServiceRequest = 'serviceRequest',
}
